import { ParameterError, AuthenticationError } from '../utils/customErrors'
import { auth } from '../utils/firebase'

export default class User {

  static async signIn(email, password) {

    if (typeof (email) !== 'string' || typeof (password) !== 'string') {
      throw new ParameterError('Incorrect parameter')
    }

    return await auth.signInWithEmailAndPassword(email, password).catch(err => {
      throw new AuthenticationError('Incorrect email or password')
    })

  }

  static isSignedIn(setState) {
    auth.onAuthStateChanged(user => {
      setState(user ? true : false)
    })
  }

  static async signOut() {
    await auth.signOut()
  }

}